import React, { useEffect, useState } from "react";
import Loader from "react-loaders";
import {
  Card,
  CardBody,
  Col,
  Modal,
  ModalHeader,
  Row,
  Button,
} from "reactstrap";
import { api } from "../../../_services/api.service";
import exceptionHandler from "../../../_helpers/exceptionHandler";

const AnswerListModal = ({
  field,
  showModal,
  toggleModal,
}) => {
  let [isLoading, setIsLoading] = useState(false);
  let [answers, setAnswers] = useState([]);

  useEffect(() => {
    if (field && field.fieldID !== -1)
      loadAnswers();
  }, [field]);

  const loadAnswers = async () => {
    setIsLoading(true);
    await api.getAnswersForField(field.fieldID)
      .then(data => {
        if (data) {
          if (field.fieldType === "List") {
            for (var i = 0; i < data.length; i++) {
              data[i].value = JSON.parse(data[i].value).join(', ');
            }
          }
          setAnswers(data);
        }
      })
      .catch(exceptionHandler);
    setIsLoading(false);
  };

  return !field ? null : (
    <Modal
      size="lg"
      isOpen={showModal}
      toggle={toggleModal}
      backdrop="static"
    >
      <ModalHeader toggle={toggleModal}>{field.fieldLabel}</ModalHeader>
      {isLoading && <Loader style={{}} type="ball-pulse" active />}
      {!isLoading && (
        <Row style={{ marginTop: "30px" }}>
          <Col md="12">
            <Card className="main-card mb-3">
              <CardBody>
                <ul>
                  {answers.length > 0 && (
                    answers.map(x => {
                      return <li>{x.value}</li>
                    })
                  )}
                </ul>

                <div className="pull-right">
                  <Button
                    color="link"
                    className="pull-right"
                    onClick={() => toggleModal()}
                  >
                    Close
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </Modal>
  );
};

export default AnswerListModal;